export function sensitiveContent() {
    const parent = $(".sensitive-content");
    parent.on("click", ".button", function (e) {
        e.preventDefault();
        $(this).parents(".sensitive-content").addClass("show-content");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/sensitiveContent.js